import React, { useRef, useCallback, useState, useMemo } from 'react';
import Tooltip from '../tooltip';
import Checkbox from '../checkbox';
const MenuItem = (props) => {
    var _a;
    const { option, label, menuItemCls, expandProps, prefixCls, isMulti, checked, indeterminate, labelContent, expandIconNode, loadingIconNode, handleMultiClick, onMultiSelect, onMouseEnter, titlePlacement } = props;
    const targetRef = useRef();
    const [overflow, setOverflow] = useState(false);
    const title = useMemo(() => {
        if ('title' in option) {
            return option.title;
        }
        if ((typeof label === 'string' || option.__IS_FILTERED_OPTION) && overflow) {
            return label;
        }
    }, [label, option, overflow]);
    const handleMouseEnter = useCallback(e => {
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
        let ele = targetRef.current;
        if (isMulti) {
            ele = ele === null || ele === void 0 ? void 0 : ele.parentNode;
        }
        const overflow = (ele === null || ele === void 0 ? void 0 : ele.scrollWidth) > (ele === null || ele === void 0 ? void 0 : ele.clientWidth);
        setOverflow(overflow);
    }, [onMouseEnter]);
    return (<Tooltip title={title} overlayClassName={`${prefixCls}-menu-item-tooltip`} placement={(_a = option.titlePlacement) !== null && _a !== void 0 ? _a : titlePlacement}>
            <li className={menuItemCls} {...expandProps} role="menuitem" disabled={option.disabled} onMouseDown={e => e.preventDefault()} onMouseEnter={handleMouseEnter}>
                <div className={`${prefixCls}-menu-item-content`} aria-disabled={option.disabled}>
                    {isMulti ? (<Checkbox className={`${prefixCls}-menu-item-checkbox`} disabled={option.disabled} checked={checked} indeterminate={indeterminate} onChange={onMultiSelect} onClick={handleMultiClick}>
                            {React.cloneElement(labelContent, {
                ref: targetRef
            })}
                        </Checkbox>) : (React.cloneElement(labelContent, {
            ref: targetRef
        }))}
                </div>
                {expandIconNode}
                {loadingIconNode}
            </li>
        </Tooltip>);
};
export default MenuItem;
